import gql from "graphql-tag";

// Payload original vem do arquivo de dump (campo resolvido sob demanda), por
// isso é buscado só ao abrir o detalhe — não na listagem.
const SHIPMENT_REQUEST_PAYLOAD_QUERY = gql`
  query ShipmentRequestPayloadQuery($id: Int!) {
    shipmentRequest(id: $id) {
      id
      code
      status
      statusMessage
      originalPayload
    }
  }
`;

export default SHIPMENT_REQUEST_PAYLOAD_QUERY;
